import React from "react";
import CloseIcon from "./close.svg";
import styles from "./Modal.css";

interface ModalProps {
  onClose: () => void;
}

export const Modal: React.FC<ModalProps> = ({ onClose, children }) => (
  <div className={styles.overlay}>
    <div className={styles.content}>
      <div className={styles.closeIcon} onClick={onClose}>
        <CloseIcon />
      </div>
      {children}
    </div>
  </div>
);
